<template>
    <v-container fluid >
        <div class="login">
            <div id="firebaseui-auth-container">
            </div>
        </div>
        <br>
        <div class="white--text">
        Signing in allows you to publish your content online.  You can share it with friends or view it on another device. See our <a @click="GoToPrivacy()">Privacy</a> policy.
        </div>
    </v-container>

</template>

<script>
import firebase from 'firebase/app'
import * as firebaseui from 'firebaseui'

export default {
  props: {},
  data () {
    return {
    }
  },
  name: 'auth',
  mounted: function () {
    if (firebase.auth().currentUser == null || firebase.auth().currentUser.email == null) {
      // FirebaseUI config.
      var uiConfig = {
        // autoUpgradeAnonymousUsers: true,
        callbacks: {
          signInSuccessWithAuthResult: function (authResult, redirectUrl) {
            console.log(authResult)
            console.log('sign in successful')

            // TODO: update the anonymous user data if the current userdoc is empty?
            // https://firebase.google.com/docs/auth/web/anonymous-auth

            // User successfully signed in.
            // Return type determines whether we continue the redirect automatically
            // or whether we leave that to developer to handle.
            return true
          },
          signInFailure: function (error) {
            // For merge conflicts, the error.code will be
            // 'firebaseui/anonymous-upgrade-merge-conflict'.
            if (error.code !== 'firebaseui/anonymous-upgrade-merge-conflict') {
              return Promise.resolve()
            }

            // Does this involve copying the anonymous scenes to the user's account?
            // console.warn("firebaseui/anonymous-upgrade-merge-conflict")
            return Promise.resolve()
          }

        },
        signInSuccessUrl: '/',
        signInOptions: [
          // Leave the lines as is for the providers you want to offer your users.
          // firebase.auth.GoogleAuthProvider.PROVIDER_ID,
          // firebase.auth.FacebookAuthProvider.PROVIDER_ID,
          // firebase.auth.TwitterAuthProvider.PROVIDER_ID,
          firebase.auth.EmailAuthProvider.PROVIDER_ID
        ],
        // Terms of service url.
        tosUrl: 'https://talkrapp.com/privacy-policy.html',
        // Privacy policy url.
        privacyPolicyUrl: 'https://talkrapp.com/privacy-policy.html',
        // remove AccountChooser website https://stackoverflow.com/questions/37369929/disable-accountchooser-for-firebase-auth/42400245

        signInFlow: 'popup',
        'credentialHelper': firebaseui.auth.CredentialHelper.NONE
      }

      // Initialize the FirebaseUI Widget using Firebase.

      var ui = firebaseui.auth.AuthUI.getInstance()
      if (!ui) {
        ui = new firebaseui.auth.AuthUI(firebase.auth())
      }
      // if (ui.isPendingRedirect()) {
      // The start method will wait until the DOM is loaded.
      ui.start('#firebaseui-auth-container', uiConfig)
      // }
    }
    // console.log('Registering Login callback')
  },
  methods: {
    GoToPrivacy: function () {
      this.$router.push({ path: '/privacy' })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Login.vue